define('views/modules/calendar/animated-session/exercise/lists/exercise-separator',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/lists/exercise-separator.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TExerciseSeparator
) {

    var VExerciseSeparator = Backbone.Epoxy.View.extend({
        template: TExerciseSeparator,
        events: {
            'click .exercise-link': 'onLinkClick',
            'touchstart .exercise-link': 'onLinkClick',
            'touchstart .link-content-top': 'onLinkClick', // Prevent iPad browsers crash
        },

        linkClass: {
            large: "tc-visible-lg",
            small: "tc-visible-sm"
        },

        initialize: function(opt) {
            opt = opt || {};

            this.role = opt.role;

            this.listenTo(this.model, "destroy", this.remove);
        },
        render: function() {

            var data = Mustache.getContext(_.extend(this.model.toJSON(), {
                isClientSide: this.role === 'client'
            }));

            this.setElement(Mustache.render(this.template, data));

            this.applyBindings();

            return this;
        },

        onLinkClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
            this.model.set('linkNext', !Boolean(this.model.get('linkNext')));
        },

    });

    return VExerciseSeparator;

});

